var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21025"
  }, /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M7.63281 0.695312V0.40625H11.3828V0.695312H10.9844C10.5677 0.695312 10.2474 0.869792 10.0234 1.21875C9.91406 1.38021 9.85938 1.75521 9.85938 2.34375V6.64062C9.85938 7.70312 9.7526 8.52865 9.53906 9.11719C9.33073 9.70052 8.91667 10.2031 8.29688 10.625C7.68229 11.0417 6.84375 11.25 5.78125 11.25C4.625 11.25 3.7474 11.0495 3.14844 10.6484C2.54948 10.2474 2.125 9.70833 1.875 9.03125C1.70833 8.56771 1.625 7.69792 1.625 6.42188V2.28125C1.625 1.63021 1.53385 1.20312 1.35156 1C1.17448 0.796875 0.885417 0.695312 0.484375 0.695312H0.0859375V0.40625H4.66406V0.695312H4.25781C3.82031 0.695312 3.50781 0.833333 3.32031 1.10938C3.1901 1.29688 3.125 1.6875 3.125 2.28125V6.89844C3.125 7.3099 3.16146 7.78125 3.23438 8.3125C3.3125 8.84375 3.45052 9.25781 3.64844 9.55469C3.84635 9.85156 4.13021 10.0964 4.5 10.2891C4.875 10.4818 5.33333 10.5781 5.875 10.5781C6.56771 10.5781 7.1875 10.4271 7.73438 10.125C8.28125 9.82292 8.65365 9.4375 8.85156 8.96875C9.05469 8.49479 9.15625 7.69531 9.15625 6.57031V2.28125C9.15625 1.61979 9.08333 1.20573 8.9375 1.03906C8.73438 0.809896 8.43229 0.695312 8.03125 0.695312H7.63281Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 78",
    d: "M0 13H11V14H0V13Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/underline.9113bc94186951a8eb223780a979af78.svg";
export { ForwardRef as ReactComponent };